export enum RoutePath {
  EMPTY = "/",
  Home = "/home",
  JobDetail = "/jobs/$jobId",
  Login = "/login",
  LoginLink = "/login-link",
  Profile = "/profile",
}

// A const object rather than enum members: the typed router needs literal route types.
export const FaqPath = {
  WhyEssence: "/faq/why-essence",
  DataUsage: "/faq/data-usage",
} as const;
